import React from 'react';

var elements 

function formatMoney(n, c, d, t) {
  var c = isNaN(c = Math.abs(c)) ? 2 : c,
    d = d == undefined ? "." : d,
    t = t == undefined ? "," : t,
    s = n < 0 ? "-" : "",
    i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
    j = (j = i.length) > 3 ? j % 3 : 0;

  return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
};

function priceCalulator(cart){
	let cartArray = cart
	let totalprice = 0.00
	let total = 0.00
	if (cartArray.length > 0){
		cartArray.map((obj, i) =>
			obj.cartObjects.map((obj2, i) =>
				total += obj2.price * obj2.quanitity
			)	
		)
		totalprice = total/100
	}
	return formatMoney(totalprice);
}

class Navigation extends React.Component {

	constructor(props){
	    // Pass props to parent class
		super(props);
		// Set initial state
		this.state = {
			cart: [],
			priceTotal: '<div></div>',
			finalPanel: false,
			finalCategory: false,
			notification: false
		}
 
	    this.setWayPoint = this.setWayPoint.bind(this);
	    this.resetWaypoints = this.resetWaypoints.bind(this);
	    this.setActiveNav = this.setActiveNav.bind(this);
	    this.goBack = this.goBack.bind(this);
	    this.goForward = this.goForward.bind(this);
	    this.updateTotal = this.updateTotal.bind(this);
	    this.setWayPointLast = this.setWayPointLast.bind(this);
	    this.setWayPointLastAccessibility = this.setWayPointLastAccessibility.bind(this);
	    this.goForwardAccessibility = this.goForwardAccessibility.bind(this);
	    this.goBackAccessibility = this.goBackAccessibility.bind(this);
	    this.panelStateLast = this.panelStateLast.bind(this);

	  }

	  panelStateLast(e, panel){
	  	if(this.state.cart.length > 0){
	  		this.setWayPoint(e, panel);
	  	}else{
	  		this.setState({
				notification: true
			}, () =>{
				setTimeout(() => {
					this.setState({
						notification: false
					});
				}, 3500);
	  		});
	  	}
	  }

	  goForward(){
	  	this.props.goForward();
	  }

	  goBack(){
	  	this.props.goBack();
	  }

	  goForwardAccessibility(e){
	  	if(e.which == 13 || e.keyCode == 13) {
	  		this.goForward(e);
	  	}
	  }

	  goBackAccessibility(e){
	  	if(e.which == 13 || e.keyCode == 13) {
	  		this.goBack(e);
	  	}
	  }

	  resetWaypoints(){
	  	for (var i = 0; i < elements.length; i++){
		    elements[i].classList.remove("active");
		    elements[i].removeAttribute("aria-current");
		}
	  }

	  setWayPointAccesibility(e,a){
	  	if(e.which == 13 || e.keyCode == 13) {
	  		this.setWayPoint(e,a);
	  	}
	  }

	  setWayPointLastAccessibility(e, a){
	  	if(this.state.cart.length > 0){
		  	if(e.which == 13 || e.keyCode == 13) {
		  		this.setWayPoint(e, a);
		  		this.setState({
					finalPanel: true
				});
		  	}
		}else{
			this.setState({
				notification: true
			}, () =>{
				setTimeout(() => {
					this.setState({
						notification: false
					});
				}, 3500);
	  		});
		}
	  }

	  setWayPointLast(e, a){
	  	if(this.state.cart.length > 0){
		  	this.setWayPoint(e, a);
		  	this.setState({
				finalPanel: true
			});
		}else{
			this.setState({
				notification: true
			}, () =>{
				setTimeout(() => {
					this.setState({
						notification: false
					});
				}, 3500);
	  		});
		}
	  }

	  setActiveNav(val){
	  	var panel = val
	  	this.resetWaypoints();
	  	elements[panel].classList.add("active");
	  	elements[panel].setAttribute("aria-current", "page")
	  	if(panel == 4){
			this.setState({
				finalCategory: false
			});
	  	}else if(panel == 5){
			this.setState({
				finalPanel: true
			});
		}else{
			this.setState({
				finalPanel: false,
				finalCategory: false
			});
		}
	  }

	  setWayPoint(e, val){

	  	this.resetWaypoints();

	  	if (val == 5){
	  		this.setState({
				finalPanel: true
			});
	  	}else{
	  		e.currentTarget.classList.add("active");
	  		e.currentTarget.setAttribute("aria-current", "page")
	  	}

		this.props.adjustPanels(val);
	
	  }

	  updateTotal(cart){
	  	let cartObj = cart
	  	this.setState({
	  		cart: cartObj,
	  		priceTotal: "TOTAL: $" + priceCalulator(cartObj)
	  	}, () =>{
	  	});
	  	
	  }

	  componentDidMount(){
	  	elements = document.getElementsByClassName('waypoint');
	  }
			  
	  render() {
    	return (
    		<div className={(this.state.finalPanel ? 'hide-navigation' : '')}>
		    	<div className={(this.props.active ? 'active navigation' : 'navigation')} >
		    		<div className={(this.props.activeOverride ? 'active inner' : 'inner')}>
						{ !this.state.finalPanel &&
						<nav className={(this.state.finalCategory ? 'final-category sticky-navigation-kit' : 'sticky-navigation-kit')} aria-label="breadcrumbs">
							<button aria-label="Go to previous panel" className="previous" onClick={this.goBack} onKeyPress={e => this.goBackAccessibility(e)}>Previous</button>

							<ul className="waypoints">
								<li role="link" aria-label="Go to welcome screen" className="waypoint active" onClick={ (e) => {this.setWayPoint( e, 0 )} } onKeyPress={(e) => {this.setWayPointAccesibility(e, 0)}} tabIndex="0">Welcome</li>
								<li role="link" aria-label="Go to diapering" aria-current="page" className="waypoint" onClick={ (e) => {this.setWayPoint( e, 1 )} } onKeyPress={(e) => {this.setWayPointAccesibility(e, 1)}} tabIndex="0">Diapering</li>
								<li role="link" aria-label="Go to laundering" className="waypoint" onClick={ (e) => {this.setWayPoint( e, 2 )} } onKeyPress={(e) => {this.setWayPointAccesibility(e, 2)}} tabIndex="0">Laundering</li>
								<li role="link" aria-label="Go to skincare" className="waypoint" onClick={ (e) => {this.setWayPoint( e, 3 )} } onKeyPress={(e) => {this.setWayPointAccesibility(e, 3)}} tabIndex="0">Skincare</li>
								<li role="link" aria-label="Go to storage" className="waypoint" onClick={ (e) => {this.setWayPoint( e, 4 )} } onKeyPress={(e) => {this.setWayPointAccesibility(e, 4)}} tabIndex="0">Storage</li>
								<li role="link" aria-label="Go to review" className="waypoint last" onClick={ (e) => {this.setWayPointLast( e, 5 )}} onKeyPress={(e) => {this.setWayPointLastAccessibility( e, 5 )}} tabIndex="0">Review</li>
								{ this.state.cart.length > 0 &&
									<div className="priceTotal" dangerouslySetInnerHTML={{__html: this.state.priceTotal}}/>
								}
							</ul>

							<button aria-label="Go to next panel" className="skip" onClick={this.goForward} onKeyPress={e => this.goForwardAccessibility(e)}>Skip</button>
						</nav>
						}
						{ this.state.finalPanel &&
							<nav class="sticky-navigation-kit last-panel-nav" aria-label="breadcrumbs">
								<ul className="waypoints">
									<li role="link" aria-disabled="true" className="waypoint">Welcome</li>
									<li role="link" aria-disabled="true" className="waypoint">Diapering</li>
									<li role="link" aria-disabled="true" className="waypoint">Laundering</li>
									<li role="link" aria-disabled="true" className="waypoint">Skincare</li>
									<li role="link" aria-disabled="true" className="waypoint">Storage</li>
									<li role="link" className="waypoint active last" aria-current="page">Review</li>
								</ul>
							</nav>
						}

						<div className={(this.state.notification ? 'active notification' : 'notification')}>
							Please add items to the system in order to review.
						</div>
					</div>

				</div>
			</div>
		)
	}
};

export default Navigation;